"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgExpand = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M10.071 18.037a1 1 0 010 2H5a1 1 0 01-1-1v-5.073a1 1 0 112 0v4.073h4.071zM13.864 6a1 1 0 110-2h5.072a1 1 0 011 1v5.073a1 1 0 01-2 0V6h-4.072z' }))); };
exports.default = SvgExpand;
//# sourceMappingURL=Expand.js.map